import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';
import Moment from 'moment';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import ReactOnRails from 'react-on-rails';
import Button from 'react-bootstrap/lib/Button';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import Radio from 'react-bootstrap/lib/Radio';
import Checkbox from 'react-bootstrap/lib/Checkbox';
import CheckboxOrRadioGroup from './CheckboxOrRadioGroup';
import SelectGroup from './SelectGroup';
import ButtonGroup from './ButtonGroup';
import FormDate from './FormDate';
import Ssn from './Ssn';
import ReactMarkdown from 'react-markdown';
import CustomFormGroup from './CustomFormGroup';
import { validator, fieldsToValidate, executeValidations, pageValid, toggleValidations } from '../../validator';
import { generateResidentElementObject, changeState, overEighteenYearsAgo, isPresent } from '../../utilities';

class ResidentForm extends React.Component {
  constructor(props){
    super(props)
    const resident = props.resident || {};
    let extraValidations = props.territory.over_eighteen_resident_validations && overEighteenYearsAgo(resident.dob)

    const initialState = {
      id: generateResidentElementObject('id', resident),
      givenNames: generateResidentElementObject('given_names', resident),
      middleNames: { val: resident.middle_names, validationKey: resident.middle_names_na ? '' : 'residents_middle_names'},
      familyName: generateResidentElementObject('family_name', resident),
      middleNamesNa: { val: resident.middle_names_na, validationKey: '' },
      gender: generateResidentElementObject('gender', resident),
      dob: generateResidentElementObject('dob', resident),
      householdPosition: generateResidentElementObject('household_position', resident),
      employer: generateResidentElementObject('employer', resident),
      relationshipToHost: generateResidentElementObject('relationship_to_host', resident),
      atHome: generateResidentElementObject('at_home', resident),
      internationalStudent: generateResidentElementObject('international_student', resident),
      ssn: generateResidentElementObject('ssn', resident),
      email: { val: resident.email, validationKey: isPresent(resident.email) || extraValidations ? 'residents_email' : '' },
      phoneMobile: { val: resident.phoneMobile, validationKey: extraValidations ? 'residents_phone_mobile' : ''},
      occupation: { val: resident.occupation, validationKey: extraValidations ? 'residents_occupation' : ''},
      education: { val: resident.education, validationKey: extraValidations ? 'residents_education' : ''}
    }

    if (props.territory.covid_vaccination_fields && !props.territory.disable_covid_questions) {
      initialState.vaccination_state = generateResidentElementObject('vaccination.state', resident, this.props.householdVaccination ? 'vaccinated' : '')
      initialState.dose_one_on = generateResidentElementObject('vaccination.dose_one_on', resident)
      initialState.dose_two_on = generateResidentElementObject('vaccination.dose_two_on', resident)
      initialState.covid_certificate_valid = generateResidentElementObject('covid_certificate_valid', resident)
    }

    this.state = initialState
    this.submit = this.submit.bind(this);
    this.changeState = this.changeState.bind(this);
    this.changeDob = this.changeDob.bind(this);
    this.handleSsn = this.handleSsn.bind(this);
  }

  getInitialState() {
    return {
      submitted: false
    };
  }

  componentWillMount(){
    executeValidations(this)
  }

  changeState = async(id, val) => {
    let extraValidations = this.props.territory.over_eighteen_resident_validations && overEighteenYearsAgo(this.state.dob.val)
    if (id == 'middleNamesNa'){
      toggleValidations(this, !val, undefined, 'middleNames', 'residents_middle_names')
    }
    if (id == 'email'){
      toggleValidations(this, isPresent(val) || extraValidations, undefined, 'email', 'residents_email')
    }

    changeState(this, id, val)
  }

  changeDob(date){
    let extraValidations = this.props.territory.over_eighteen_resident_validations && overEighteenYearsAgo(date)
    toggleValidations(this, extraValidations, undefined, 'email', 'residents_email')
    toggleValidations(this, extraValidations, undefined, 'phoneMobile', 'residents_phone_mobile')
    toggleValidations(this, extraValidations, undefined, 'occupation', 'residents_occupation')
    toggleValidations(this, extraValidations, undefined, 'education', 'residents_education')
    this.changeState('dob', date)
  }

  handleSsn(ssn){
    this.changeState('ssn', ssn)
  }

  submit(e){
    e.preventDefault();
    this.setState({submitted: true})

    const submitData = {
      authenticity_token: ReactOnRails.authenticityToken(),
      host_resident: {
        id: this.state.id.val,
        gender: this.state.gender.val,
        dob: this.state.dob.val,
        given_names: this.state.givenNames.val,
        family_name: this.state.familyName.val,
        middle_names: this.state.middleNames.val,
        middle_names_na: this.state.middleNamesNa.val,
        household_position: this.state.householdPosition.val,
        relationship_to_host: this.state.relationshipToHost.val,
        occupation: this.state.occupation.val,
        employer: this.state.employer.val,
        education: this.state.education.val,
        phone_mobile: this.state.phoneMobile.val,
        email: this.state.email.val,
        at_home: this.state.atHome.val,
        international_student: this.state.internationalStudent.val,
        ssn: this.state.ssn.val
      }
    }

    if (this.props.territory.covid_vaccination_fields && !this.props.territory.disable_covid_questions) {
      submitData.host_resident.vaccination = {
        state: this.state.vaccination_state.val,
        dose_one_on: this.state.dose_one_on.val,
        dose_two_on: this.state.dose_two_on.val,
      }
      submitData.host_resident.vaccination.state = this.state.vaccination_state.val
      submitData.host_resident.vaccination.dose_one_on = this.state.dose_one_on.val
      submitData.host_resident.vaccination.dose_two_on = this.state.dose_two_on.val
    }

    this.props.onResidentFormSubmit(submitData)
    this.props.onClose();
  }

  render() {
    const { formatMessage } = this.props.intl;
    const genderSelections = [
      [formatMessage(defaultMessages.clientCommonMale), 'Male'],
      [formatMessage(defaultMessages.clientCommonFemale), 'Female'],
      [formatMessage(defaultMessages.clientCommonOtherGender), 'Other']
    ];
    const ButtonTitle = this.state.id.val ? defaultMessages.clientHostPagesResidentsButtonsUpdate : defaultMessages.clientHostPagesResidentsButtonsCreate;
    const showCovidQuestions = this.props.territory.covid_vaccination_fields && !this.props.territory.disable_covid_questions

    return (
      <div className="residents-form">
        <form className="signup-form">
          {
            (this.state.id) &&
            <FormControl id={'id'} type='hidden' defaultValue={this.state.id.val} />
          }
          <CustomFormGroup valid={this.state.givenNames.valid}>
            <FormControl
              id="givenNames"
              placeholder={formatMessage(defaultMessages.clientHostPagesResidentsPlaceholdersGivenNames)}
              type="text"
              componentClass="input"
              defaultValue={this.state.givenNames.val}
              onChange={e => this.changeState(e.target.id, e.target.value)} />
          </CustomFormGroup>

          <CustomFormGroup valid={this.state.middleNames.valid}>
            <ControlLabel>{formatMessage(defaultMessages.clientHostPagesResidentsLabelsMiddleNames)}</ControlLabel>
            {
              this.props.requiredFields.residents_middle_names &&
              <Checkbox
                style={{float: 'right', marginTop: '0px', marginBottom: '0px'}}
                checked={this.state.middleNamesNa.val}
                id="middleNamesNa"
                onChange={e => this.changeState(e.target.id, !this.state.middleNamesNa.val)} >
                {formatMessage(defaultMessages.clientHostPagesResidentsLabelsNotApplicable)}
              </Checkbox>
            }
            <FormControl
              id="middleNames"
              placeholder={formatMessage(defaultMessages.clientHostPagesResidentsPlaceholdersMiddleNames)}
              type="text"
              componentClass="input"
              defaultValue={this.state.middleNames.val}
              onChange={e => this.changeState(e.target.id, e.target.value)} />
            {
              this.props.requiredFields.residents_middle_names &&
              <ReactMarkdown source={this.props.content.pages.residents.middle_name_info}/>
            }
          </CustomFormGroup>

          <CustomFormGroup valid={this.state.familyName.valid}>
            <FormControl
              id="familyName"
              placeholder={formatMessage(defaultMessages.clientHostPagesResidentsPlaceholdersFamilyName)}
              type="text"
              componentClass="input"
              defaultValue={this.state.familyName.val}
              onChange={e => this.changeState(e.target.id, e.target.value)} />
          </CustomFormGroup>

          <SelectGroup
            title={''}
            setId={'resident_gender'}
            placeholder={formatMessage(defaultMessages.clientHostPagesResidentsPlaceholdersGender)}
            options={genderSelections}
            valid={this.state.gender.valid}
            defaultValue={this.state.gender.val}
            controlFunc={e => this.changeState('gender', e.target.value)} />

          <CustomFormGroup valid={this.state.dob.valid}>
            <ControlLabel>{formatMessage(defaultMessages.clientHostPagesResidentsLabelsDob)}</ControlLabel>
            <FormDate
              id="DobDate"
              updateDateState={this.changeDob}
              date={this.state.dob.val}
              intl={this.props.intl} />
          </CustomFormGroup>

          <Ssn
            ssn={this.state.ssn.val ? this.state.ssn.val.replace(/^.{6}/g, '******')  : ''}
            content={this.props.content}
            handleSelection={this.handleSsn}
            valid={this.state.ssn.valid} />

          <CustomFormGroup valid={this.state.email.valid}>
            <FormControl
              id="email"
              placeholder={formatMessage(defaultMessages.clientHostPagesResidentsPlaceholdersEmail)}
              type="text"
              componentClass="input"
              defaultValue={this.state.email.val}
              onChange={e => this.changeState(e.target.id, e.target.value)} />
            {
              this.props.requiredFields.residents_email &&
              <ReactMarkdown source={this.props.content.pages.residents.email_info}/>
            }
          </CustomFormGroup>

          <CustomFormGroup valid={this.state.phoneMobile.valid}>
            <FormControl
              id="phoneMobile"
              placeholder={formatMessage(defaultMessages.clientHostPagesResidentsPlaceholdersPhoneMobile)}
              type="text"
              componentClass="input"
              defaultValue={this.state.phoneMobile.val}
              onChange={e => this.changeState(e.target.id, e.target.value)} />
          </CustomFormGroup>

          <CustomFormGroup valid={this.state.occupation.valid}>
            <FormControl
              id="occupation"
              placeholder={formatMessage(defaultMessages.clientHostPagesResidentsPlaceholdersOccupation)}
              type="text"
              componentClass="input"
              defaultValue={this.state.occupation.val}
              onChange={e => this.changeState(e.target.id, e.target.value)} />
          </CustomFormGroup>

          <CustomFormGroup valid={this.state.education.valid}>
            <FormControl
              id="education"
              placeholder={formatMessage(defaultMessages.clientHostPagesResidentsPlaceholdersEducation)}
              type="text"
              componentClass="input"
              defaultValue={this.state.education.val}
              onChange={e => this.changeState(e.target.id, e.target.value)} />
          </CustomFormGroup>

          <CustomFormGroup valid={this.state.relationshipToHost.valid}>
            <FormControl
              id="relationshipToHost"
              placeholder={formatMessage(defaultMessages.clientHostPagesResidentsPlaceholdersRelationshipToHost)}
              type="text"
              componentClass="input"
              defaultValue={this.state.relationshipToHost.val}
              onChange={e => this.changeState(e.target.id, e.target.value)} />
          </CustomFormGroup>

          <CustomFormGroup valid={this.state.householdPosition.valid}>
            <FormControl
              id="householdPosition"
              placeholder={formatMessage(defaultMessages.clientHostPagesResidentsPlaceholdersHouseholdPosition)}
              type="text"
              componentClass="input"
              defaultValue={this.state.householdPosition.val}
              onChange={e => this.changeState(e.target.id, e.target.value)} />
          </CustomFormGroup>

          <CustomFormGroup valid={this.state.employer.valid}>
            <FormControl
              id="employer"
              placeholder={formatMessage(defaultMessages.clientHostPagesResidentsPlaceholdersEmployer)}
              type="text"
              componentClass="input"
              defaultValue={this.state.employer.val}
              onChange={e => this.changeState(e.target.id, e.target.value)} />
          </CustomFormGroup>

          {showCovidQuestions && (
            <div style={{ marginBottom: '1.2em', marginTop: '1.2em' }}>
              <hr />
              <CustomFormGroup valid={this.state.vaccination_state.valid}>
                <CheckboxOrRadioGroup
                  title={formatMessage(defaultMessages.clientHostPagesResidentsLabelsCovidVaccinationStatus)}
                  setName={'vaccination_state'}
                  type={'radio'}
                  checkBoxStyle={'radio-inline'}
                  controlFunc={e => this.changeState('vaccination_state', e.target.value)}
                  options={this.props.residentVaccinationOptions}
                  selectedOptions={[String(this.state.vaccination_state.val)]}
                  valid={this.state.vaccination_state.valid} />
              </CustomFormGroup>
              {this.state.vaccination_state.val === 'vaccinated' && !this.state.covid_certificate_valid.val && this.props.vaccinationMandatory && (
                <>
                  <CustomFormGroup valid={this.state.dose_one_on.valid}>
                    <ControlLabel>{formatMessage(defaultMessages.clientHostPagesResidentsLabelsCovidVaccinationDose1)}</ControlLabel>
                    <FormDate
                      id="CovidVaccinationDose1"
                      updateDateState={date => this.changeState('dose_one_on', date)}
                      date={this.state.dose_one_on.val}
                      intl={this.props.intl} />
                  </CustomFormGroup>

                  <CustomFormGroup valid={this.state.dose_two_on.valid}>
                    <ControlLabel>{formatMessage(defaultMessages.clientHostPagesResidentsLabelsCovidVaccinationDose2)}</ControlLabel>
                    <FormDate
                      id="CovidVaccinationDose2"
                      updateDateState={date => this.changeState('dose_two_on', date)}
                      date={this.state.dose_two_on.val}
                      intl={this.props.intl} />
                  </CustomFormGroup>
                </>
              )}
              <hr />
            </div>
          )}


          <Checkbox
            id="atHome"
            checked={this.state.atHome.val}
            onChange={e => this.changeState(e.target.id, !this.state.atHome.val)}>
            {formatMessage(defaultMessages.clientHostPagesResidentsLabelsAtHome)}
          </Checkbox>

          <Checkbox
            id="internationalStudent"
            checked={this.state.internationalStudent.val}
            onChange={e => this.changeState(e.target.id, !this.state.internationalStudent.val)}>
            {formatMessage(defaultMessages.clientHostPagesResidentsLabelsInternationalStudent)}
          </Checkbox>

          <Button
            id="resident-submit"
            className="btn-primary"
            onClick={this.submit}
            disabled={!pageValid(this.state, this.props.requiredFields)}
          >
              {formatMessage(ButtonTitle)}
          </Button>
        </form>
      </div>
    )
  }
};

ResidentForm.propTypes = {
   onHostProfileSubmit: PropTypes.func,
   onSkipSubmit: PropTypes.func,
   onGoBack: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};

export default injectIntl(ResidentForm);
